export class AtlSegmentedControlButtonClickEvent extends Event{
    static EVENT_NAME = "atlantis-segmented-control-button-click";

    constructor() {
      super(AtlSegmentedControlButtonClickEvent.EVENT_NAME, {
        bubbles: true,
        composed: true,
      });
    }
}